import BlockFull2Col from '../../components/Common/BlockFull2Col'

export default function NewYear() {
  return (
    <BlockFull2Col
      inverted
      title='christmas.happyNewYear'
      titleColor='#caa760'
      bgColor='#2f2a28'
      description={['christmas.happyNewYear.description']}
      image='https://meteor.stullercloud.com/das/126384657'
    />
  )
}
